






































































import Component from 'vue-class-component';
import { Vue } from 'vue-property-decorator';
import SetPasswordUserDialog from '../page/useradmin/user/SetPasswordUserDialog.vue';
// import UpdateUserDialog from '@/custom/page/useradmin/user/UpdateUserDialog.vue';
import LoginService from '@/account/login.service';

@Component({ components: { SetPasswordUserDialog } })
export default class TcgNavbar extends Vue {
  model: number = null;

  mobileMode = false;
  mounted() {
    if (this.$route.fullPath.indexOf('/mobile/') >= 0) {
      this.mobileMode = true;
    }
  }
  goBack() {
    this.$router.go(-1);
  }

  get userInfo() {
    // console.log(account);
    return this.$store.getters.account;
  }

  get showGoBack() {
    return this.$route.path !== '/login' && this.$route.path !== '/';
  }

  logout() {
    // localStorage.removeItem('jhi-authenticationToken');
    // sessionStorage.removeItem('jhi-authenticationToken');
    // this.$store.commit('logout');
    new LoginService().logout().then(response => {
      this.$store.commit('logout');
      window.location.href = response.data.logoutUrl;
      const next = response.data?.logoutUrl ?? '/';
      if (this.$route.path !== next) {
        return this.$router.push(next);
      }
      if (this.$route.path !== '/login') {
        return this.$router.push('/login');
      }
    });
    return Promise.resolve(this.$router.currentRoute);
  }

  resetPasswordDialog = {
    open: false,
    user: {
      login: '',
      newPassword: '',
    },
  };

  updateUserDialog = {
    open: false,
    user: {},
  };

  changePassword() {
    this.resetPasswordDialog.user.login = this.$store.getters.account?.login || '';
    this.resetPasswordDialog = {
      ...this.resetPasswordDialog,
      open: true,
    };
  }

  updateUser() {
    this.updateUserDialog = {
      open: true,
      user: this.$store.getters.account,
    };
  }
}
